export const SHOWCASE_STYLES = {
	containerBase:
		"border border-slate-600 p-7 rounded-xl gap-5 w-full bg-[#0404048e] overflow-auto",
	card: "h-auto w-full flex text-left flex-col m-auto p-2 gap-5 rounded-md border",
	title: "underline font-semibold underline-offset-4 text-amber-200 p-2 text-start",
	subtitle: "text-center my-5 md:mt-20 leading-3 font-bold",
};

const GRID_COLUMNS = {
	1: "grid grid-cols-1",
	2: "grid grid-cols-1 md:grid-cols-2",
	4: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4",
};

export function createShowcaseBoxStyle(columns = 1) {
	const gridClass = GRID_COLUMNS[columns] ?? GRID_COLUMNS[1];
	const father = `${gridClass} ${SHOWCASE_STYLES.containerBase}`;

	return {
		father,
		padre: father,
		hijo: SHOWCASE_STYLES.card,
		title: SHOWCASE_STYLES.title,
		titulo: SHOWCASE_STYLES.title,
		subtitle: SHOWCASE_STYLES.subtitle,
		subtitulo: SHOWCASE_STYLES.subtitle,
	};
}


